import { render } from "./ListeOrganisationPage.vue?vue&type=template&id=71d645f5&ts=true"
import script from "./ListeOrganisationPage.vue?vue&type=script&lang=ts"
export * from "./ListeOrganisationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__